exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "li[id^='rbt-menu-item'] {\n  pointer-events: none;\n}\n", ""]);

